import React from "react";
import styled, { keyframes } from "styled-components";
import { colors2, UI_BODY_SM_DF } from "oolib";

const shimmerSweep = keyframes`
  from { background-position: 100% 0; }
  to { background-position: -100% 0; }
`;

// Text-clipped gradient band sweeping across the text. Static base colour
// under prefers-reduced-motion — the text itself is the status.
const StyledShimmerText = styled(UI_BODY_SM_DF)<{ $baseColor: string; $highlightColor: string }>`
  background: linear-gradient(
    90deg,
    ${({ $baseColor }) => $baseColor} 0%,
    ${({ $baseColor }) => $baseColor} 40%,
    ${({ $highlightColor }) => $highlightColor} 50%,
    ${({ $baseColor }) => $baseColor} 60%,
    ${({ $baseColor }) => $baseColor} 100%
  );
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: ${shimmerSweep} 2s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    color: ${({ $baseColor }) => $baseColor};
  }
`;

interface ShimmerTextProps {
  children: React.ReactNode;
  baseColor?: string;
  highlightColor?: string;
}

export const ShimmerText = ({
  children,
  baseColor = colors2.grey50,
  highlightColor = colors2.grey90,
}: ShimmerTextProps) => (
  <StyledShimmerText $baseColor={baseColor} $highlightColor={highlightColor}>
    {children}
  </StyledShimmerText>
);
